export default function () {

    const $ = jQuery;
    const $form = $('[data-component="stickerform"]');

    if (!$form.length) return;

    // Steps that are currently part of the flow (option steps of a non-chosen type are [hidden])
    function visibleSteps() {
        return $form.find('.stickerform__step').not('[hidden]');
    }

    function renumberSteps() {
        visibleSteps().each(function (index) {
            $(this).find('[data-number]').first().text(index + 1);
        });
    }

    function openStep($step) {
        $form.find('.stickerform__step[open]').removeAttr('open');
        if ($step && $step.length) {
            $step.attr('open', true);
        }
    }

    function resetStep($step) {
        $step.removeClass('is-done').removeAttr('open');
        $step.find('input[type="radio"]').prop('checked', false);
        $step.find('[data-choice]').first().text('');
    }

    // FAQ/accordion behaviour: only one step open at a time
    $form.on('click', '.stickerform__step-summary', function (e) {
        e.preventDefault();

        const $step = $(this).closest('.stickerform__step');
        const isOpen = $step.attr('open') !== undefined;

        $form.find('.stickerform__step[open]').not($step).removeAttr('open');

        if (isOpen) {
            $step.removeAttr('open');
        } else {
            $step.attr('open', true);
        }
    });

    const $custom = $form.find('.stickerform__custom');
    const customLimits = $custom.data('limits') || {};

    // Per-type quantity staffel (kwantumkorting): { typeSlug: { quantity: discount } }.
    // Source of truth is the configurator (Configurator_Options/Price); the tiles for
    // the chosen product are built in buildStaffelTiles() so they match the server.
    const staffels = $form.data('staffels') || {};
    let staffel = {};
    let staffelTiers = [];

    // (Re)build the quantity tiles for a product's staffel and pick the lowest tier.
    function buildStaffelTiles(typeSlug) {
        staffel = staffels[typeSlug] || {};
        staffelTiers = Object.keys(staffel).map(Number).sort((a, b) => a - b);

        const $staffelBlock = $form.find('[data-quantity-staffel]');
        const $grid = $form.find('.stickerform__options--quantity');

        // No staffel for this product → hide the kwantumkorting tiles, but keep the
        // "Eigen aantal" field so the amount can still be changed.
        if (!staffelTiers.length) {
            $grid.html('');
            $form.find('input[name="stickerform_quantity"][data-quantity="radio"]').prop('checked', false).val('');
            $staffelBlock.prop('hidden', true);
            return;
        }

        $staffelBlock.prop('hidden', false);

        if (!$grid.length) return;

        const defaultQty = staffelTiers[0] || 1;

        $grid.html(staffelTiers.map((qty) => {
            const discount = staffel[qty] || 0;
            const save = discount > 0
                ? `<span class="stickerform__quantity-save">${Math.round(discount * 100)}% besparing</span>`
                : '';
            const checked = qty === defaultQty ? 'checked' : '';

            return `
                <label class="stickerform__option stickerform__option--quantity">
                    <input type="radio" name="stickerform_quantity" value="${qty}" data-discount="${discount}" data-label="${qty} stuks" ${checked}>
                    <span class="stickerform__quantity-amount">${qty} stuks</span>
                    <span class="stickerform__quantity-price" data-tier-price>&mdash;</span>
                    ${save}
                </label>
            `;
        }).join(''));

        // Reset any custom quantity; default to the lowest tier of this product.
        $form.find('[data-quantity="radio"]').prop('checked', false).val('');
        $form.find('[data-quantity="input"]').val(defaultQty);
    }

    function currentLimits() {
        const shape = $form.find('input[name="stickerform_shape"]:checked').val();
        return customLimits[shape] || null;
    }

    // Discount fraction for a quantity: the highest tier whose quantity is <= qty
    // (0 below the first tier). Mirrors Configurator_Price::discountFor().
    function discountFor(quantity) {
        let discount = 0;
        staffelTiers.forEach((tierQty) => {
            if (quantity >= tierQty) {
                discount = staffel[tierQty];
            }
        });
        return discount;
    }

    function formatPrice(amount) {
        return '€ ' + amount.toFixed(2).replace('.', ',');
    }

    // Overview of every chosen step with the price each choice adds
    function updateSummary(basePrice) {
        const $summary = $form.find('[data-summary]');
        const rows = [];

        visibleSteps().each(function () {
            const $step = $(this);
            const $input = $step.find('input:checked').first();

            if (!$input.length) return;

            const title = $step.find('.stickerform__step-summary').attr('data-summary-label');
            const label = $input.attr('data-label') || $input.val();
            let price = '';

            if ($step.data('step') === 'size' && basePrice != null) {
                price = formatPrice(basePrice);
            } else {
                const extra = parseFloat($input.attr('data-extra-price')) || 0;

                if (extra > 0) {
                    price = '+ ' + formatPrice(extra);
                }
            }

            rows.push(`
                <div class="stickerform__summary-row">
                    <div class="stickerform__summary-info">
                        <strong>${title}</strong>
                        <span>${label}</span>
                    </div>
                    ${price ? `<span class="stickerform__summary-price">${price}</span>` : ''}
                </div>
            `);
        });

        $summary.prop('hidden', !rows.length).html(rows.join(''));
    }

    // Currently selected quantity (a tier or the custom value); falls back to the
    // lowest tier so the total always has something to multiply with.
    function selectedQuantity() {
        const value = parseInt($form.find('input[name="stickerform_quantity"]:checked').val(), 10);
        if (!isNaN(value) && value > 0) {
            return value;
        }
        return staffelTiers[0] || 1;
    }

    // Fill in the price of every staffel tile: unit price x tier qty x (1 - discount).
    function updateStaffelGrid(unitPrice) {
        $form.find('.stickerform__option--quantity').each(function () {
            const $tier = $(this);
            const qty = parseInt($tier.find('input').val(), 10);
            const discount = parseFloat($tier.find('input').attr('data-discount')) || 0;
            const $price = $tier.find('[data-tier-price]');

            if (unitPrice == null || isNaN(qty)) {
                $price.html('&mdash;');
            } else {
                $price.text(formatPrice(unitPrice * qty * (1 - discount)));
            }
        });
    }

    // Unit price = m² of the chosen size x price_m2 of the chosen shape + the
    // extra_price of every chosen option. The total then applies the quantity
    // staffel: unit price x quantity x (1 - discount).
    function updatePrice() {
        const $total = $form.find('[data-total]');
        const limits = currentLimits();
        const size = $form.find('input[name="stickerform_size"]:checked').val();

        let basePrice = null;

        if (limits && size && size.includes('x')) {
            const [width, height] = size.split('x').map(parseFloat);
            const m2 = (width / 100) * (height / 100); // sizes are in cm
            // Per-shape minimum price (min_sticker); can differ per shape/product
            const minPrice = parseFloat(limits.min) || parseFloat($form.attr('data-min-price')) || 0;

            basePrice = Math.max(m2 * limits.priceM2, minPrice);
        }

        let extras = 0;

        $form.find('[data-step="option"]:not([hidden]) input:checked').each(function () {
            extras += parseFloat($(this).attr('data-extra-price')) || 0;
        });

        const unitPrice = basePrice == null ? null : basePrice + extras;

        updateStaffelGrid(unitPrice);

        if (unitPrice == null) {
            $total.html('&mdash;');
        } else {
            const quantity = selectedQuantity();
            $total.text(formatPrice(unitPrice * quantity * (1 - discountFor(quantity))));
        }

        updateSummary(basePrice);
    }

    // Shape chosen: only show the sizes of that shape (3x3 grid)
    $form.on('change', 'input[name="stickerform_shape"]', function () {
        const shape = $(this).val();
        const $sizeStep = $form.find('[data-step="size"]');

        $sizeStep.find('.stickerform__option--size').each(function () {
            const matches = $(this).data('shape') === shape;

            $(this).prop('hidden', !matches);

            if (!matches) {
                $(this).find('input').prop('checked', false);
            }
        });

        $sizeStep.find('.stickerform__options-empty').hide();

        // Reset the custom size, its limits depend on the shape
        $custom.find('[data-custom="radio"]').prop('checked', false).val('');
        $custom.find('input[type="number"]').val('');
        $custom.find('[data-custom="error"]').text('');

        const limits = customLimits[shape];

        if (limits) {
            $custom.find('[data-custom="hint"]').text(
                `Min. ${limits.min} cm per zijde, max. ${limits.maxW} x ${limits.maxH} cm (max. ${limits.maxM2} m²)`
            );
            $custom.find('input[type="number"]').attr('min', limits.min);
            $custom.find('[data-custom="width"]').attr('max', limits.maxW);
            $custom.find('[data-custom="height"]').attr('max', limits.maxH);
        }

        // The previously chosen size belonged to another shape, clear the step
        if (!$sizeStep.find('input:checked').length) {
            $sizeStep.removeClass('is-done').find('[data-choice]').first().text('');
        }
    });

    // Custom size: validate against the limits of the chosen shape and select it
    $form.on('click', '[data-action="stickerform_custom_size"]', function () {
        const limits = currentLimits();
        const $error = $custom.find('[data-custom="error"]');
        const width = parseFloat($custom.find('[data-custom="width"]').val());
        const height = parseFloat($custom.find('[data-custom="height"]').val());

        $error.text('');

        if (!limits) {
            $error.text('Kies eerst een vorm.');
            return;
        }

        if (isNaN(width) || isNaN(height)) {
            $error.text('Vul een breedte en hoogte in.');
            return;
        }

        if (width < limits.min || height < limits.min) {
            $error.text(`Beide zijdes moeten minimaal ${limits.min} cm zijn.`);
            return;
        }

        if (width > limits.maxW || height > limits.maxH) {
            $error.text(`Maximaal ${limits.maxW} x ${limits.maxH} cm voor deze vorm.`);
            return;
        }

        const m2 = (width / 100) * (height / 100);

        if (m2 > limits.maxM2) {
            $error.text(`Maximaal ${limits.maxM2} m² per sticker.`);
            return;
        }

        $custom.find('[data-custom="radio"]')
            .val(`${width}x${height}`)
            .attr('data-label', `${width} x ${height} cm`)
            .prop('checked', true)
            .trigger('change');
    });

    // Custom quantity: validate and select it via the hidden quantity radio
    $form.on('click', '[data-action="stickerform_custom_quantity"]', function () {
        const $quantity = $form.find('.stickerform__quantity');
        const quantity = parseInt($quantity.find('[data-quantity="input"]').val(), 10);

        if (isNaN(quantity) || quantity < 1) {
            $quantity.find('[data-quantity="input"]').val(staffelTiers[0] || 1);
            return;
        }

        $quantity.find('[data-quantity="radio"]')
            .val(quantity)
            .attr('data-label', `${quantity} stuks`)
            .prop('checked', true)
            .trigger('change');
    });

    // Type chosen: only show the option steps that belong to that type
    $form.on('change', 'input[name="stickerform_type"]', function () {
        const type = $(this).val();

        $form.find('[data-step="option"]').each(function () {
            const matches = $(this).data('type') === type;

            $(this).prop('hidden', !matches);

            if (!matches) {
                resetStep($(this));
            }
        });

        // Rebuild the quantity tiles for this product's staffel.
        buildStaffelTiles(type);

        renumberSteps();
    });

    // Any choice made: show it in the summary, mark the step done and open the next step.
    // Bound after the handlers above so visibility is up-to-date when picking the next step.
    $form.on('change', 'input[type="radio"]', function () {
        const $input = $(this);
        const $step = $input.closest('.stickerform__step');

        $step.addClass('is-done');
        $step.find('[data-choice]').first().text($input.attr('data-label') || $input.val());

        updatePrice();

        const $steps = visibleSteps();
        openStep($steps.eq($steps.index($step) + 1));
    });

    // Info tooltip: don't select the radio when clicking the icon, toggle for touch devices
    $form.on('click', '.stickerform__option-info', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $form.find('.stickerform__option-info.is-open').not(this).removeClass('is-open');
        $(this).toggleClass('is-open');
    });

    $(document).on('click', function () {
        $form.find('.stickerform__option-info.is-open').removeClass('is-open');
    });

    // Create build: gather the chosen options, create a configurator build and go to it
    $(document).on('click', '[data-action="stickerform_create_build"]', function (e) {
        e.preventDefault();

        const $button = $(this);

        if ($button.hasClass('is-loading')) return;

        const shape = $form.find('input[name="stickerform_shape"]:checked').val();
        const size = $form.find('input[name="stickerform_size"]:checked').val();
        const type = $form.find('input[name="stickerform_type"]:checked').val();

        if (!shape || !size || !type) {
            window.alert('Maak eerst een keuze voor vorm, formaat en levering.');
            return;
        }

        $button.addClass('is-loading');

        // serialize() collects shape, size, type and the checked option radios of
        // the chosen type; the PHP handler reads exactly what it needs from those.
        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: $form.serialize() + '&action=create_sticker_build&nonce=' + ajaxNonce,
            success: function (response) {
                if (response.success && response.data && response.data.redirect) {
                    window.location.href = response.data.redirect;
                    return;
                }

                window.alert(response.data && response.data.message ? response.data.message : 'Er ging iets mis.');
                $button.removeClass('is-loading');
            },
            error: function () {
                window.alert('Er ging iets mis.');
                $button.removeClass('is-loading');
            }
        });
    });

    // Preselect the product type that matches the URL slug, e.g.
    // /raamstickers-bestellen/ → value "raamstickers". Compares the first path
    // segment (without "-bestellen") against the normalized value and label of
    // every type radio, so "one-way-vision-bestellen" also matches "One Way vision".
    (function preselectTypeFromUrl() {
        const segment = window.location.pathname.split('/').filter(Boolean)[0] || '';
        if (!segment) return;

        const normalize = (text) => String(text).toLowerCase().replace(/[^a-z0-9]/g, '');
        const keyword = normalize(segment.toLowerCase().replace(/-bestellen$/, ''));
        if (!keyword) return;

        const $match = $form.find('input[name="stickerform_type"]').filter(function () {
            const value = normalize($(this).val());
            const label = normalize($(this).attr('data-label') || '');

            return (value && (value.includes(keyword) || keyword.includes(value))) ||
                (label && (label.includes(keyword) || keyword.includes(label)));
        }).first();

        if (!$match.length || $match.prop('checked')) return;

        $match.prop('checked', true).trigger('change');

        // trigger('change') opens the step after "type"; on page load the form
        // should still start collapsed at the first step (shape).
        openStep(visibleSteps().first());
    })();

    // Build the staffel tiles for the selected product (hides the step when the
    // product has no staffel, or when nothing is selected yet).
    buildStaffelTiles($form.find('input[name="stickerform_type"]:checked').val() || '');

    renumberSteps();
    updatePrice();

}